module.exports = __webpack_public_path__ + "img/silver_back.a5885cef.png";